import CoreIconsLegacyChangelogs from "../../../../../core-icons/CHANGELOG_LEGACY.md";
import * as React from 'react';
export default {
  CoreIconsLegacyChangelogs,
  React
};